import type { ReactNode } from 'react'
import { useAuth } from '../auth/AuthContext'
import { Navbar } from './Navbar'
import { Footer } from './Footer'
import { AdminBar } from './AdminBar'

export function SiteLayout({ children }: { children: ReactNode }) {
  const { user } = useAuth()
  return (
    <div className={user ? 'pt-6' : ''}>
      <a href="#contenu" className="skip-link">Aller au contenu</a>
      <AdminBar />
      <Navbar />
      <main id="contenu">{children}</main>
      <Footer />
    </div>
  )
}
